require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-seattle-tech-company-recruits-python-students-to-build-sdk-as-class-project.json") })
        }
      }, "path---blog-seattle-tech-company-recruits-python-students-to-build-sdk-as-class-project");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-seattle-tech-company-recruits-python-students-to-build-sdk-as-class-project!./.cache/json/blog-seattle-tech-company-recruits-python-students-to-build-sdk-as-class-project.json
// module id = 1059
// module chunks = 231608221292675